/**
 * we should wrap all upsell components in this HoC to ensure that they are only rendered for admins
 *
 * RCTECH BI: premium upsell prompts are disabled entirely on this build, so this
 * always renders null regardless of the wrapped component's props.
 */
export function UpsellWrapper<Props extends object>(
  _Component: React.ComponentType<Props>,
) {
  const WrappedComponent = (_props: Props) => {
    return null;
  };

  return WrappedComponent;
}
